import React from 'react'
import { useMediaQuery } from '@mui/material'
import { BasePagination } from 'components/shared/BasePagination'
import { useSearchParams } from 'react-router-dom'
import {
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid'
import { theme } from 'theme'

export default function CustomPagination() {
  const apiRef = useGridApiContext()
  const page = useGridSelector(apiRef, gridPageSelector)
  const pageCount = useGridSelector(apiRef, gridPageCountSelector)
  const matchesXS = useMediaQuery(theme.breakpoints.down('sm'))

  const [searchParams, setSearchParams] = useSearchParams()

  const handleChange = (e: React.ChangeEvent, v: number) => {
    const nextPage = v - 1
    apiRef.current.setPage(nextPage)
    if (v > 1) {
      searchParams.set('page', `${v}`)
    } else {
      searchParams.delete('page')
    }
    setSearchParams(searchParams)
  }
  return (
    <BasePagination
      color="primary"
      count={pageCount}
      page={page + 1}
      onChange={handleChange}
      sx={{ display: pageCount ? 'default' : 'none' }}
      siblingCount={matchesXS ? -1 : 2}
      boundaryCount={1}
    />
  )
}
